import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

// The render function now accepts bubbleInstance and initialDataJSON
window.renderReactFlowApp = (containerId, bubbleInstance, initialDataJSON) => {
  const container = document.getElementById(containerId);
  if (!container) {
    if (window.reportErrorToBubble) {
      window.reportErrorToBubble(`Container with id "${containerId}" not found.`, 'renderReactFlowApp');
    }
    return;
  }
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App bubbleInstance={bubbleInstance} initialDataJSON={initialDataJSON} />
      </ErrorBoundary>
    </React.StrictMode>
  );
};

// This part allows your app to still run standalone on Cloudflare Pages
if (document.getElementById('root')) {
    const mockBubbleInstance = {
        publishState: () => {},
        triggerEvent: () => {},
    };
    // Initialize with a blank canvas
    window.renderReactFlowApp('root', mockBubbleInstance, null);
}

